import { useMemo } from 'react';
import { useData } from './DataProvider';
import buildTexts from '../constants/texts';

export function useTexts() {
  const { config, time } = useData();
  return useMemo(() => buildTexts(config, time), [config, time]);
}
